export default __webpack_public_path__ + "519b28010d320967d5571f2ad871f012.png";